export function Settings() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold">Settings</h1>
        <p className="text-muted-foreground mt-2">
          Manage your account and tenant settings
        </p>
      </div>
      
      <div className="space-y-4">
        <div className="border rounded-lg p-6">
          <h2 className="text-xl font-semibold mb-2">Profile Settings</h2>
          <p className="text-sm text-muted-foreground">Form will go here</p>
        </div>
        
        <div className="border rounded-lg p-6">
          <h2 className="text-xl font-semibold mb-2">Tenant Information</h2>
          <p className="text-sm text-muted-foreground">Tenant details will go here</p>
        </div>
        
        <div className="border rounded-lg p-6">
          <h2 className="text-xl font-semibold mb-2">Billing & Subscription</h2>
          <p className="text-sm text-muted-foreground">Subscription info will go here</p>
        </div>
      </div>
    </div>
  )
}
